import common from './modules/common.js'
import courseManage from './modules/courseManage.js'
import myCourse from './modules/myCourse.js'
import question from './modules/question.js'
import examCenter from './modules/examCenter.js'
import myExam from './modules/myExam.js'
import paper from './modules/paper.js'
import accessCard from './modules/accessCard.js'
import resourceManage from './modules/resourceManage.js'

export default {
  common,
  courseManage,
  myCourse,
  question,
  examCenter,
  myExam,
  paper,
  accessCard,
  resourceManage
}


// WEBPACK FOOTER //
// ./src/api/index.js